module.exports = __webpack_public_path__ + "static/img/sc13.23f697f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/sc13.png
// module id = pLnw
// module chunks = 25